// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__7L95f","label":"styles_label__MrdBt","icon":"styles_icon__bnWpN"};